import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  main: {
    position: 'relative',
    padding: 10,
    marginBottom: 20,
  },
  addButton: {
    position: 'fixed',
    bottom: 30,
    right: 'calc(50% - 28px)',
    color: theme.backgrounds.cardBackground,
  },
  webView: {
    background: theme.webView.background,
  },
}))

export default useStyles
